import * as React from "react";
const FluidReportDraftView = React.lazy(() => import("./FluidReportDraftViewContainer"));

export { FluidReportDraftView };
